import { useLocation, Outlet } from 'react-router-dom';
import { Box, Container, Typography, Stack } from '@mui/material';

import Logo from '../../components/Logo';

import MainFooter from './MainFooter';
import MainHeader from './MainHeader';
import Version from '../../components/Version';

export default function MainLayout() {
  const { pathname } = useLocation();

  const isHome = pathname === '/';

  return (
    <Stack sx={{ minHeight: 1 }}>
      <MainHeader />

      <Outlet />

      <Box sx={{ flexGrow: 1 }} />

      {!isHome ? (
        <MainFooter />
      ) : (
        <Box
          sx={{
            py: 5,
            textAlign: 'center',
            position: 'relative',
            bgcolor: 'background.default',
          }}
        >
          <Container>
            <Logo sx={{ mb: 1, mx: 'auto' }} />

            <Typography variant="caption" component="p">
              © All rights reserved
            </Typography>

            <Version />
          </Container>
        </Box>
      )}
    </Stack>
  );
}
